module.exports = __webpack_public_path__ + "static/media/ezugi-casino.d6d238d0.webp";